import React, { Suspense } from "react";
import { Card, CardHeader, Box, Grid, Tabs, Tab } from "@mui/material";
import UserList from "../components/user/UserList";
import "../styles/user.css";
import { Route, Routes } from "react-router-dom";
import User from "../routes/User";
import UserStats from "../components/user/UserStats";
import UnassignedUserList from "../components/user/UnassignedUserList";
import "../styles/user.css";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateUserTile from "../components/user/CreateUserTile";

const Users = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        exact
        element={
          <div className="fragmentContainer">
            <Grid container spacing={2}>
              <Suspense fallback={<StatSkeleton />}>
                <UserStats />
              </Suspense>
              <CreateUserTile />
              <Grid item xs={12} md={12} lg={12}>
                {/* <Card>
                  <CardHeader title="Users"></CardHeader>
                  <UserList {...props} />
                </Card> */}
                <Card>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChange}>
                      <Tab
                        label={`${localStorage.selectedCustomer} Users`}
                        {...a11yProps(0)}
                      />
                      <Tab label="Unassigned Users" {...a11yProps(1)} />
                    </Tabs>
                  </Box>
                  <div className="tabs-container">
                    <CustomTabPanel value={value} index={0}>
                      <UserList {...props} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <UnassignedUserList {...props} />
                    </CustomTabPanel>
                  </div>
                </Card>
              </Grid>
            </Grid>
          </div>
        }
      />
      <Route path="/:userId/*" element={<User />} />
    </Routes>
  );
};

export default Users;
